<div class="permission-matrix">
  <!-- Controls Bar -->
  <div class="matrix-controls">
    <div class="controls-actions">
      <button type="button" class="btn-link-action" (click)="expandAll()">Expand all</button>
      <span class="divider-pipe">|</span>
      <button type="button" class="btn-link-action" (click)="collapseAll()">Collapse all</button>
      <span class="divider-pipe">|</span>
      <button type="button" class="btn-link-action" (click)="selectAll()">Select all</button>
      <span class="divider-pipe">|</span>
      <button type="button" class="btn-link-action" (click)="clearAll()">Clear all</button>
    </div>

    <!-- Count Display -->
    <div class="matrix-summary">
      {{ getGrantedCount() }} of {{ getTotalPermissionsCount() }} permissions granted
    </div>
  </div>

  <!-- Accordion List -->
  <div [formGroup]="form">
    <div formArrayName="modules" class="accordion-container">
      @for (modGroup of modules.controls; track modGroup; let idx = $index) {
        <div [formGroupName]="idx"
          class="module-card" [class.is-expanded]="expandedModules[modGroup.get('name')?.value]">

          <!-- Accordion Header -->
          <div class="module-header" (click)="toggleModule(modGroup.get('name')?.value)">
            <div class="module-header__left">
              <span class="chevron-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                </svg>
              </span>

              <!-- Module Icons -->
              <span class="module-icon">
                @switch (modGroup.get('name')?.value) {
                  @case ('User Management') {
                    <img src="assets/icons/users.svg" alt="User Management" width="18" height="18" />
                  }
                  @case ('Roles & Permissions') {
                    <img src="assets/icons/shield.svg" alt="Roles & Permissions" width="18" height="18" />
                  }
                  @case ('Geographic Nodes') {
                    <img src="assets/icons/pin.svg" alt="Geographic Nodes" width="18" height="18" />
                  }
                  @case ('Channels') {
                    <img src="assets/icons/check.svg" alt="Channels" width="18" height="18" />
                  }
                  @case ('POS') {
                    <img src="assets/icons/settings.svg" alt="POS" width="18" height="18" />
                  }
                  @case ('SKU Management') {
                    <img src="assets/icons/sku_rules.svg" alt="SKU Management" width="18" height="18" />
                  }
                  @case ('Surveys') {
                    <img src="assets/icons/surveys.svg" alt="Surveys" width="18" height="18" />
                  }
                  @case ('Dispatch & Operations') {
                    <img src="assets/icons/dispatch_&_operations.svg" alt="Dispatch & Operations" width="18" height="18" />
                  }
                  @case ('Reports & Analytics') {
                    <img src="assets/icons/reports_&_analytics.svg" alt="Reports & Analytics" width="18" height="18" />
                  }
                  @case ('System Settings') {
                    <img src="assets/icons/settings.svg" alt="System Settings" width="18" height="18" />
                  }
                  @default {
                    <img src="assets/icons/check.svg" alt="Module" width="18" height="18" />
                  }
                }
              </span>

              <span class="module-name">{{ modGroup.get('name')?.value }}</span>
            </div>

            <!-- Progress bar + status + enable all -->
            <div class="module-header__right" (click)="$event.stopPropagation()">
              <!-- Thin progress bar -->
              <div class="module-progress">
                <div class="module-progress__fill"
                  [style.width.%]="(getModuleGrantedCount(idx) / getModuleTotalCount(idx)) * 100"></div>
              </div>

              <!-- Status badge -->
              <span class="module-status-badge">
                {{ getModuleGrantedCount(idx) === 0 ? 'None' : getModuleGrantedCount(idx) + '/' + getModuleTotalCount(idx) }}
              </span>

              <!-- Enable All Checkbox -->
              <div class="enable-all">
                <label class="enable-all__label" [for]="'enableAll_' + idx">Enable all</label>
                <input class="enable-all__input" type="checkbox" [id]="'enableAll_' + idx"
                  [checked]="isModuleFullySelected(idx)" [indeterminate]="isModulePartiallySelected(idx)"
                  (click)="toggleEnableAllModule(idx, $event)" />
              </div>
            </div>
          </div>

          <!-- Accordion Body -->
          @if (expandedModules[modGroup.get('name')?.value]) {
            <div class="module-body" formGroupName="permissions">
              <div class="permissions-list">
                @for (perm of MODULES_DEF[idx].permissions; track perm.code) {
                  <div class="permission-row">
                    <div class="permission-row__checkbox">
                      <input type="checkbox" [formControlName]="perm.code" [id]="perm.code"
                        class="perm-checkbox" (change)="onPermissionCheckboxChange(idx, perm.code)" />
                    </div>
                    <div class="permission-row__info">
                      <label [for]="perm.code" class="permission-row__name">
                        <span>{{ perm.name }}</span>
                        <code class="permission-row__code">{{ perm.code }}</code>
                      </label>
                      <span class="permission-row__desc">{{ perm.description }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

        </div>
      }
    </div>
  </div>
</div>
